import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'yesNo'
})
export class YesNoPipe implements PipeTransform {
    transform(value : string | boolean) {
        if (value === true) return 'Yes';
        if (value === false) return 'No';

        if (value == null || value == '') return '';

        let lower = value.toLowerCase();
        
        if (lower == 'y' || lower == 'yes') return 'Yes';
        if (lower == 'n' || lower == 'no') return 'No';

        return value;
    }
}


// WEBPACK FOOTER //
// ./src/pipes/yesno.pipe.ts